import { isDesktop } from '../desktop';

export const useIsDesktop = () => {
	return {
		isDesktop: isDesktop(),
	};
};
